import { UpdateType, VersionUpdateInfo } from './VersionHistoryList'

// turn 'create' into 'created', 'edit' into 'edited', etc.
export const getPastTense = (stringIn: UpdateType | undefined) => {
  if (!stringIn) return ''
  return `${stringIn}${stringIn[stringIn.length - 1] === 'e' ? 'd' : 'ed'}`
}

export const getUpdateTypeString = (updateInfo: VersionUpdateInfo) => {
  if (!updateInfo) return ''
  return updateInfo?.type === 'create'
    ? ''
    : ` (${getPastTense(updateInfo?.type)} from version ${updateInfo?.from_version || NaN})`
}
